import { Component, Input } from '@angular/core';
import { ErStatusKind, normalizeStatus } from './status';

/** The one dot — transaction state only. */
@Component({
  selector: 'er-status-dot',
  template: `<span class="er-dot" [ngClass]="cls" [attr.aria-label]="status"></span>`
})
export class ErStatusDotComponent {
  @Input() status: string | null | undefined;

  get kind(): ErStatusKind { return normalizeStatus(this.status); }
  get cls(): string { return this.kind === 'neutral' ? '' : 'er-dot--' + this.kind; }
}
